<template>
    <iframe ref="iframe" class="marketing-iframe" :src="block.src" @load="resizeIFrameToFitContent"/>
</template>

<script>

export default {
    name: "StaticPage",
    props: ['block'],
    data: () => ({
        isAllowed: false,
    }),
    methods: {
        resizeIFrameToFitContent() {
            //iFrame.width = iFrame.contentWindow.document.body.scrollWidth;
            this.$refs.iframe.height = this.$refs.iframe.contentWindow.document.body.scrollHeight;
        }
    },
    watch: {
        state() {
            this.isAllowed = ALLOWED_STATES.indexOf(this.state) !== -1;
        }
    },
    created() {
        this.isAllowed = ALLOWED_STATES.indexOf(this.state) !== -1;
    },
    mounted() {
        addEventListener("resize", this.resizeIFrameToFitContent)
    }
}
</script>

<style scoped>
.marketing-iframe {
    width: 100%;
    border: none !important;
}
</style>